// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1G6gZ","title":"Images90_title__2uKJL","images":"Images90_images__2cRLc"};